// @ts-expect-error not typed
import CopilotPreview from 'ai-addon-copilot-preview/components/CopilotPreview/CopilotPreview';
// @ts-expect-error not typed
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotCallSummary = ({
  usageTracker,
  callId
}) => {
  return /*#__PURE__*/_jsx(CopilotProvider, {
    children: /*#__PURE__*/_jsx(CopilotPreview, {
      appName: "recording-review-ui",
      copilotAction: {
        intent: 'object_summary',
        objectId: `${callId}`,
        objectTypeId: '0-48',
        objectTypeLabel: 'call',
        label: `with id ${callId}`
      },
      copilotActionButtonText: "Summarize this call",
      previewTitle: "Summary",
      usageTracker: usageTracker,
      previewKey: `0-4fff:${callId}`,
      previewSource: "CALLING_SUMMARY"
    })
  });
};
export default CopilotCallSummary;